import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
type Props = {
  photo_url?: string | null;
  name: string;
} & React.ComponentPropsWithoutRef<'div'>;
export function Avatar(t0) {
  const $ = _c(12);
  const {
    photo_url,
    className,
    name
  } = t0;
  if (photo_url) {
    const t1 = photo_url || "/img/noPhoto.svg";
    const t2 = `Avatar for ${name || "user"}`;
    let t3;
    if ($[0] !== className) {
      t3 = twMerge("rounded-full object-cover", className);
      $[0] = className;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
      t4 = <Image width={480} height={480} src={t1} alt={t2} priority={true} className={t3} />;
      $[2] = t1;
      $[3] = t2;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  const t1 = `Avatar for ${name || "user"}`;
  let t2;
  if ($[6] !== className) {
    t2 = twMerge("inline-block size-16 overflow-hidden rounded-full border border-zinc-200 bg-zinc-300/80", "dark:border-zinc-500 dark:bg-transparent", className);
    $[6] = className;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg fill="currentColor" viewBox="0 0 24 24" className="size-full text-white dark:text-zinc-500" aria-hidden="true"><path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" /></svg>;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2) {
    t4 = <div role="img" aria-label={t1} className={t2}>{t3}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}